require('./marketableOperationOKButton.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @commons
const { OKButton } = require('commonsComponents/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @utilities
const { formatText } = require('core/i18n').i18n;

class MarketableOperationOKButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let button;
        let innerTooltipButton;

        if (this.props.disabled && this.props.disabledTooltipText) {
            innerTooltipButton = (
                <span>
                    <OKButton {...this.props}>
                        {this.props.children}
                    </OKButton>
                </span>
            );

            button = (
                <OKTooltip
                    content={this.props.disabledTooltipText}
                    offset={[0, -15]}
                    target={innerTooltipButton}
                />
            )
        } else {
            button = (
                <OKButton {...this.props}>
                    {this.props.children}
                </OKButton>
            );
        }

        return button;
    }
}

MarketableOperationOKButton.defaultProps = {
    disabled: false,
    disabledTooltipText: formatText('broker-notMarketableProduct') || false
}

MarketableOperationOKButton.propTypes = {
    disabled: PropTypes.bool,
    children: PropTypes.object,
    disabledTooltipText: PropTypes.string
};

module.exports = MarketableOperationOKButton;